<template>
    <div v-if="benefits.length" class="flex flex-col gap-3">
        <p v-if="title" class="text-sm font-semibold text-theme-base">
            {{ title }}
        </p>
        <ul class="flex flex-col gap-3">
            <li
                v-for="benefit in benefits"
                :key="benefit.feature"
                class="flex items-start gap-3"
                data-test="plan-benefit"
            >
                <span
                    class="flex items-center justify-center flex-shrink-0 w-9 h-9 rounded-xl bg-theme-hover text-lg"
                    aria-hidden="true"
                >
                    {{ benefit.icon }}
                </span>
                <div class="flex flex-col">
                    <span class="text-sm font-semibold text-theme-base">
                        {{ benefit.label }}
                    </span>
                    <span class="text-sm text-theme-muted">
                        {{ benefit.description }}
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { planBenefits } from "@/common/fields/plan-features";

// portal-sesion-y-candados-optimizacion: misma lista de beneficios en la
// tarjeta del home y en los modales de planes, desde el mirror estático.
export default {
    name: "PlanBenefitsList",
    props: {
        // Code del plan cuyos beneficios se muestran (starter, pro, premium).
        planCode: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        }
    },
    computed: {
        benefits() {
            return planBenefits(this.planCode);
        }
    }
};
</script>
